/**
 * @generated SignedSource<<92c72481cc38bef0102a91d60bd05e79>>
 * @relayHash 6cea685c9924366c2af428afbd2c9db0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 241eb5800bdeb1396fa6af59016e3c2a8656a26b5a747492d4bab9a2a7d4db90

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AggDirectoryViewQuery$variables = {
  q?: string | null | undefined;
  scopeId: string;
};
export type AggDirectoryViewQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AggDirectoryViewPaginationQuery">;
};
export type AggDirectoryViewQuery = {
  response: AggDirectoryViewQuery$data;
  variables: AggDirectoryViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "q"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scopeId"
},
v2 = {
  "kind": "Variable",
  "name": "q",
  "variableName": "q"
},
v3 = {
  "kind": "Variable",
  "name": "scopeId",
  "variableName": "scopeId"
},
v4 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 24
  },
  (v2/*: any*/),
  (v3/*: any*/)
],
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v7 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "AggDirectoryViewQuery",
    "selections": [
      {
        "args": [
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "AggDirectoryViewPaginationQuery"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "AggDirectoryViewQuery",
    "selections": [
      {
        "concreteType": "TeamQuery",
        "kind": "LinkedField",
        "name": "team",
        "plural": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "concreteType": "TeamConnection",
            "kind": "LinkedField",
            "name": "teamsTql",
            "plural": false,
            "selections": [
              {
                "concreteType": "TeamConnectionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TeamV2",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "displayName"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "largeAvatarImageUrl"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "state"
                      },
                      {
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 100
                          }
                        ],
                        "concreteType": "TeamMemberConnectionV2",
                        "kind": "LinkedField",
                        "name": "members",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TeamMemberEdgeV2",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TeamMemberV2",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "member",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      (v5/*: any*/),
                                      (v7/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "picture"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "accountId"
                                      }
                                    ]
                                  }
                                ]
                              },
                              (v6/*: any*/)
                            ]
                          }
                        ],
                        "storageKey": "members(first:100)"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isVerified"
                      },
                      {
                        "concreteType": "TeamType",
                        "kind": "LinkedField",
                        "name": "type",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v5/*: any*/),
                          (v7/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "verified"
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "description"
                      },
                      {
                        "concreteType": "TeamHierarchy",
                        "kind": "LinkedField",
                        "name": "hierarchy",
                        "plural": false,
                        "selections": [
                          {
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "first",
                                "value": 25
                              }
                            ],
                            "concreteType": "TeamChildrenConnection",
                            "kind": "LinkedField",
                            "name": "children",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TeamChildrenEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  (v6/*: any*/)
                                ]
                              }
                            ],
                            "storageKey": "children(first:25)"
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "smallAvatarImageUrl"
                      },
                      (v6/*: any*/)
                    ]
                  },
                  (v6/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "cursor"
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "endCursor"
                  }
                ]
              }
            ]
          },
          {
            "args": (v4/*: any*/),
            "filters": [
              "scopeId",
              "q"
            ],
            "handle": "connection",
            "key": "AggDirectoryView_teamsTql",
            "kind": "LinkedHandle",
            "name": "teamsTql"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "241eb5800bdeb1396fa6af59016e3c2a8656a26b5a747492d4bab9a2a7d4db90",
    "metadata": {},
    "name": "AggDirectoryViewQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "ea36ad4c7cd1f5b9a5d84cd5524eb74d";

export default node;
